import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavIcon from './NavIcon';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="bottom-navigation">
      <Link 
        to="/" 
        className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}
      >
        <NavIcon type="home" size={24} isActive={location.pathname === '/'} />
        <span className="nav-label">ANA SAYFA</span>
      </Link>
      <Link 
        to="/kadro" 
        className={`nav-item ${location.pathname === '/kadro' ? 'active' : ''}`}
      >
        <NavIcon type="squad" size={24} isActive={location.pathname === '/kadro'} />
        <span className="nav-label">KADRO</span>
      </Link>
      <Link 
        to="/puan-durumu" 
        className={`nav-item ${location.pathname === '/puan-durumu' ? 'active' : ''}`}
      >
        <NavIcon type="standings" size={24} isActive={location.pathname === '/puan-durumu'} />
        <span className="nav-label">PUAN DURUMU</span>
      </Link>
      <Link 
        to="/gecmis" 
        className={`nav-item ${location.pathname === '/gecmis' ? 'active' : ''}`}
      >
        <NavIcon type="history" size={24} isActive={location.pathname === '/gecmis'} />
        <span className="nav-label">GEÇMİŞ</span>
      </Link>
    </nav>
  );
};

export default Navigation;



